import { createRouter, createWebHashHistory } from 'vue-router'
import { useIndexStore } from '@/store'
import centerRoutes from './modules/center'
import config from '@/config'
const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  ...centerRoutes
]
const modulesFiles = import.meta.glob('./modules/*.js', { eager: true })
//自动引入module包
const moduleRoutes = Object.entries(modulesFiles).reduce((moduleRoutes, [modulePath, value]) => {
  return [...moduleRoutes, ...value.default]
}, [])

const router = createRouter({
  history: createWebHashHistory(),
  scrollBehavior: () => ({ left: 0, top: 0 }),
  routes: [...routes, ...moduleRoutes]
})

const queryCode = (query) => {
  const value = Array.isArray(query?.code) ? query.code[0] : query?.code
  return value ? String(value) : ''
}

router.beforeEach((to, from, next) => {
  const routeCode = queryCode(to.query)
  const isFirstLoad = from.matched.length === 0 && !from.name
  const searchCode = isFirstLoad && typeof window !== 'undefined'
    ? new URLSearchParams(window.location.search).get('code') || ''
    : ''
  const code = routeCode || searchCode
  if (code && to.path !== '/team') {
    return next({ path: '/team', query: { code } })
  }
  if (code && to.path === '/team' && !routeCode) {
    return next({ path: '/team', query: { code } })
  }
  if (config.isVerifyToken) {
    const store = useIndexStore()
    const openedByInvite = to.path === '/team' && !!code
    if (!store.token && to.path !== '/index' && !openedByInvite) {
      return next({ path: '/index' })
    }
  }
  next()
})
export default router
